export enum masterInfoTypes {
  FETCH_MASTER_INFO_REQUEST = "FETCH_MASTER_INFO_REQUEST",
  FETCH_MASTER_INFO_SUCCESS = "FETCH_MASTER_INFO_SUCCESS",
  FETCH_MASTER_INFO_FAILURE = "FETCH_MASTER_INFO_FAILURE",
}